import script from "./ItemTexto.vue?vue&type=script&setup=true&lang=js"
export * from "./ItemTexto.vue?vue&type=script&setup=true&lang=js"

import "./ItemTexto.vue?vue&type=style&index=0&id=070cbb0a&scoped=true&lang=css"

import exportComponent from "/var/www/html/resources/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-070cbb0a"]])

export default __exports__